import { createPayment, getPaymentQuote } from "../api";

export const submitLiqPayPayment = (paymentData) => {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = "https://www.liqpay.ua/api/3/checkout/";

  const inputData = document.createElement("input");
  inputData.type = "hidden";
  inputData.name = "data";
  inputData.value = paymentData.data;

  const inputSignature = document.createElement("input");
  inputSignature.type = "hidden";
  inputSignature.name = "signature";
  inputSignature.value = paymentData.signature;

  form.appendChild(inputData);
  form.appendChild(inputSignature);
  document.body.appendChild(form);
  form.submit();
};

export const initiatePayment = async (bookingId, { confirmNewPrice = false } = {}) => {
  const paymentData = await createPayment(bookingId, { confirmNewPrice });
  submitLiqPayPayment(paymentData);
};

export const checkPaymentPrice = async (bookingId) => {
  return getPaymentQuote(bookingId);
};
